module.exports = {"label":{"date":"Datum (UTC)"},"timeRel":{"on":"am","before":"vor dem","after":"nach dem","beforeMonth":"vor","afterMonth":"nach"}}